import actions from "./actions";
import mutations from "./mutations";

export const initialState = () => {
  return {
    showDialog: false,
    dialogTitle: "Title",
    okText: "Ok",
    cancelText: "Cancel",
    onOk: () => {},
    onCancel: () => {},
    resolve: null,
    maxWidth: null,
    icon: undefined,
    content: [],
    autofocus: null,
    layer: 0
  };
};

export const genericInputDialogModule = {
  state: initialState(),
  namespaced: true,
  getters: {},
  actions,
  mutations
};
